import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { grey1, purple7 } from 'approot/shared/styles/colours.style';
import { standardFocusState } from 'approot/shared/styles/borders.style';

type DeleteStyledProps = {
  $isDisabled?: boolean;
};

export const DeleteStyled = styled.button<DeleteStyledProps>`
  margin-left: auto;
  padding: 0;
  border: 0;
  background: ${purple7};
  border-radius: 50%;
  cursor: pointer;
  color: ${grey1};
  width: ${rem(36)};
  height: ${rem(36)};
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    stroke: ${grey1};
  }

  ${props =>
    props.$isDisabled &&
    `
    opacity: 0.75;
    cursor: not-allowed;
  `}

  ${standardFocusState}
`;
